var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"video",attrs:{"muted":"","autoplay":"","loop":"","playsinline":"","src":_vm.videoObjectURL},domProps:{"muted":true},on:{"mouseover":_vm.mouseOver,"mouseleave":_vm.mouseLeave,"ended":_vm.videoEnded}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1671c827","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Video.vue
// module id = null
// module chunks = 